import { createFileRoute, redirect } from '@tanstack/react-router'

import { DIALOG_PATHS } from '~/lib/dialogs'

/**
 * The address settings' nutrition section wears while it is open — a mask over the page
 * underneath, per `specs/tech.spec.md`. This route catches the address arriving on its own:
 * a shared link, a bookmark, a reload. There is no page underneath to open over then, so it
 * opens over the timeline, and keeps the address it was asked for.
 */
export const Route = createFileRoute('/settings_/nutrition')({
  beforeLoad: () => {
    redirect({
      to: '/',
      search: { dialog: 'nutrition' },
      throw: true,
      mask: { to: DIALOG_PATHS.nutrition },
    })
  },
})
